


































import type { ProfilUtilisateur } from "@/model/bean/GeneratedDTOs"
import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import { ValidationObserver } from "vee-validate"
import RadioWithInputAndValidation from "@/views/inputs/RadioWithInputAndValidation.vue"

@Component({
  components: {
    ValidationObserver,
    RadioWithInputAndValidation,
  },
})
export default class ProfilSelectionView extends Vue {
  @Prop() value: ProfilUtilisateur

  profils: string[] = ["ENSEIGNANT", "REFERENT", "SOUS_PROFIL"]

  sousProfils: ProfilUtilisateur[] = [
    "ACCOMPAGNATEUR_REGIONAL",
    "OBSERVATEUR_NATIONAL",
    "ACCOMPAGNATEUR_NATIONAL",
  ]

  selectedProfil: string = this.profils[0]
  profilsLabels = this.profils.map((profil) => {
    return this.$t(
      `registerPage.profil-label-${profil.toLowerCase().replace(/_/g, "-")}`
    ).toString()
  })
  profilsHelpNotices = this.profils.map((profil) => {
    return this.$t(`registerPage.tooltip-${profil.toLowerCase().replace(/_/g, "-")}`).toString()
  })

  selectedSousProfil: ProfilUtilisateur = this.sousProfils[0]
  sousProfilsLabels = this.sousProfils.map((profil) => {
    return this.$t(
      `registerPage.profil-label-${profil.toLowerCase().replace(/_/g, "-")}`
    ).toString()
  })
  sousProfilsHelpNotices = this.sousProfils.map((profil) => {
    return this.$t(`registerPage.tooltip-${profil.toLowerCase().replace(/_/g, "-")}`).toString()
  })

  isSousProfilSelected = false

  @Watch("selectedProfil")
  setIsSousProfilSelected(): void {
    this.isSousProfilSelected = this.selectedProfil === "SOUS_PROFIL"
  }

  created(): void {
    if (this.value) {
      if (this.value === "ENSEIGNANT" || this.value === "REFERENT") {
        this.selectedProfil = this.value
      } else {
        this.selectedProfil = "SOUS_PROFIL"
        this.selectedSousProfil = this.value
      }
    }
  }

  getInputSelectProfil(): ProfilUtilisateur {
    if (this.isSousProfilSelected) {
      return this.selectedSousProfil
    } else {
      // Convertir selectedProfil en ProfilUtilisateur si valide
      if (this.isValidProfil(this.selectedProfil)) {
        return this.selectedProfil as ProfilUtilisateur
      }
      throw new Error("Le profil sélectionné est invalide !")
    }
  }

  isValidProfil(profil: string): profil is ProfilUtilisateur {
    return [
      "SUPER_ADMINISTRATEUR",
      "ACCOMPAGNATEUR_NATIONAL",
      "ACCOMPAGNATEUR_REGIONAL",
      "ANIMATEUR_REGIONAL",
      "REFERENT",
      "ENSEIGNANT",
      "OBSERVATEUR_NATIONAL",
    ].includes(profil)
  }

  submit(): void {
    this.$emit("input-profil", this.getInputSelectProfil())
  }

  goBack(): void {
    this.$emit("go-back", this.getInputSelectProfil())
  }
}
